import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Name of candidate offered:", -1);
const _hoisted_3 = { class: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2" };
const _hoisted_4 = { class: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Current Stage:", -1);
const _hoisted_6 = { class: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2" };
const _hoisted_7 = { class: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6" };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Current Assignee:", -1);
const _hoisted_9 = { class: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2" };
const _hoisted_10 = { class: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6" };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Status:", -1);
const _hoisted_12 = { class: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2" };
const _hoisted_13 = { class: "flex flex-row justify-end w-full" };
const _hoisted_14 = { key: 0 };
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("p", null, "Please confirm that the offer has been returned and can now be closed", -1);
const _hoisted_16 = {
    key: 1,
    class: "ml-2"
};
const _hoisted_17 = {
    key: 2,
    class: "ml-2"
};
const _hoisted_18 = { class: "lg:hidden" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_activity_feed = _resolveComponent("activity-feed");
    const _component_approval_steps = _resolveComponent("approval-steps");
    const _component_form_layout = _resolveComponent("form-layout");
    const _component_CheckIcon = _resolveComponent("CheckIcon");
    const _component_ModalWindow = _resolveComponent("ModalWindow");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createVNode(_component_form_layout, {
            "nav-item-config": _ctx.currentStage?.stageName === 'offer.notifyTermsHaveChanged' ? _ctx.navItemConfigChanges : _ctx.navItemConfig,
            "current-nav-item": _ctx.currentNavItem,
            "form-point": _ctx.formPoint,
            "form-data": _ctx.formData,
            "hide-action": _ctx.hideAction && !_ctx.currentUserIsAssigned,
            "display-header": _ctx.showApprovalSteps,
            "display-timeline": _ctx.showApprovalSteps,
            "display-footer": false,
            onSetCurrentNavItem: _ctx.setCurrentNavItem
        }, {
            pageTitle: _withCtx(() => [
                _createTextVNode("Approval to Recruit (ATR)")
            ]),
            header: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                    _hoisted_2,
                    _createTextVNode(),
                    _createElementVNode("dd", _hoisted_3, _toDisplayString(_ctx.formData.candidateName), 1)
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_4, [
                    _hoisted_5,
                    _createTextVNode(),
                    _createElementVNode("dd", _hoisted_6, _toDisplayString(_ctx.currentStage.displayName), 1)
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createTextVNode(),
                    _createElementVNode("dd", _hoisted_9, _toDisplayString(_ctx.formData.atr?.formOne?.hiringManagerEmail ?? _ctx.formData.currentAssigneeEmail), 1)
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createTextVNode(),
                    _createElementVNode("dd", _hoisted_12, _toDisplayString(_ctx.formData.status), 1)
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_13, [
                    (_ctx.currentStage?.stageName === 'offer.notifyOfferSent' && _ctx.profile?.H2R)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _hoisted_15,
                            _createTextVNode(),
                            _createElementVNode("button", {
                                type: "button",
                                class: "inline-flex items-center justify-center rounded-md border border-transparent bg-green-700 hover:bg-green-800 hover:underline px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-green-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto",
                                onClick: _cache[0] || (_cache[0] =
                                    //@ts-ignore
                                    (...args) => (_ctx.confirmOffer && _ctx.confirmOffer(...args)))
                            }, "Confirm")
                        ]))
                        : _createCommentVNode("", true),
                    _createTextVNode(),
                    ((_ctx.profile?.ADMIN || _ctx.formData.requestedBy === _ctx.profile?.userID) && _ctx.formData.status !== 'CANCELLED')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "inline-flex items-center justify-center rounded-md border border-transparent bg-red-700 hover:bg-red-800 hover:underline px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-green-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto",
                                onClick: _cache[1] || (_cache[1] =
                                    //@ts-ignore
                                    (...args) => (_ctx.cancelOffer && _ctx.cancelOffer(...args)))
                            }, "Cancel Offer")
                        ]))
                        : _createCommentVNode("", true),
                    _createTextVNode(),
                    (_ctx.profile?.ADMIN || _ctx.profile?.H2R || _ctx.profile?.RESOURCING)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "inline-flex items-center justify-center rounded-md border border-transparent bg-green-700 hover:bg-green-800 hover:underline px-4 py-2 text-sm font-medium text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto",
                                onClick: _cache[2] || (_cache[2] =
                                    //@ts-ignore
                                    (...args) => (_ctx.hanldeReassign && _ctx.hanldeReassign(...args)))
                            }, "Re-assign")
                        ]))
                        : _createCommentVNode("", true)
                ])
            ]),
            navFooter: _withCtx(() => [
                (_ctx.currentStage?.stageName === 'offer.notifyTermsHaveChanged' && _ctx.profile.userID === _ctx.formData.requestedBy)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "w-full inline-flex items-center justify-center rounded-md border border-transparent bg-green-700 hover:bg-green-800 hover:underline px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-green-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2",
                        onClick: _cache[3] || (_cache[3] =
                            //@ts-ignore
                            (...args) => (_ctx.handleReapprove && _ctx.handleReapprove(...args)))
                    }, "Send for Re-Approval"))
                    : _createCommentVNode("", true)
            ]),
            main: _withCtx(() => [
                (_ctx.formData.atr)
                    ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentNavItem.component), {
                        key: 0,
                        atr: _ctx.formData.atr,
                        "atr-ready-to-submit": _ctx.atrReadyToSubmit,
                        "config-data": _ctx.configData,
                        "config-items": _ctx.configData,
                        document: _ctx.formData,
                        "form-data": _ctx.formData[_ctx.currentNavItem.name] ? _ctx.formData[_ctx.currentNavItem.name] : _ctx.formData.atr[_ctx.currentNavItem.name],
                        data: _ctx.formData.atr,
                        "show-approval-steps": _ctx.currentStage?.stageName !== 'offer.notifyTermsHaveChanged',
                        "disable-form": _ctx.disableForm,
                        status: _ctx.formData.status,
                        "for-reapproval": _ctx.forReapproval,
                        "onUpdate:formData": _ctx.handleUpdateFormData,
                        "onUpdate:reset": _ctx.handleResetFormData,
                        onSubmitForm: _ctx.handleSubmitForm,
                        onCompleteOffer: _ctx.handleCompleteOffer
                    }, null, 40, ["atr", "atr-ready-to-submit", "config-data", "config-items", "document", "form-data", "data", "show-approval-steps", "disable-form", "status", "for-reapproval", "onUpdate:formData", "onUpdate:reset", "onSubmitForm", "onCompleteOffer"]))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("button", {
                        class: "w-full text-center px-4 py-2 rounded-md text-white bg-green-700 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 bg-no-repeat",
                        onClick: _cache[4] || (_cache[4] =
                            //@ts-ignore
                            (...args) => (_ctx.openApprovalModal && _ctx.openApprovalModal(...args)))
                    }, "\n          Action\n        ")
                ])
            ]),
            timeline: _withCtx(() => [
                (_ctx.formData.activityList)
                    ? (_openBlock(), _createBlock(_component_activity_feed, {
                        key: 0,
                        "activity-list": _ctx.formData?.activityList
                    }, null, 8, ["activity-list"]))
                    : _createCommentVNode("", true)
            ]),
            footer: _withCtx(() => [
                (_ctx.formData.shortId)
                    ? (_openBlock(), _createBlock(_component_approval_steps, {
                        key: 0,
                        "form-data": _ctx.formData,
                        "doc-type": "STARTER",
                        onComment: _cache[5] || (_cache[5] = ($event) => (_ctx.fetchSingleAtr(_ctx.formData.docId)))
                    }, null, 8, ["form-data"]))
                    : _createCommentVNode("", true)
            ]),
            _: 1
        }, 8, ["nav-item-config", "current-nav-item", "form-point", "form-data", "hide-action", "display-header", "display-timeline", "onSetCurrentNavItem"]),
        _createTextVNode(),
        (_ctx.showModal)
            ? (_openBlock(), _createBlock(_component_ModalWindow, {
                key: 0,
                onClose: _ctx.handleModalClose
            }, {
                icon: _withCtx(() => [
                    _createVNode(_component_CheckIcon, {
                        class: "h-6 w-6 text-green-600",
                        "aria-hidden": "true"
                    })
                ]),
                title: _withCtx(() => [
                    _createTextVNode("ATR Approval")
                ]),
                subtitle: _withCtx(() => [
                    _createTextVNode("What would you like to do with this ATR?")
                ]),
                footer: _withCtx(() => [
                    _createElementVNode("button", {
                        type: "button",
                        class: "inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 my-2 bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm",
                        onClick: _cache[6] || (_cache[6] =
                            //@ts-ignore
                            (...args) => (_ctx.handleApproveAtr && _ctx.handleApproveAtr(...args)))
                    }, "\n        Approve\n      ")
                ]),
                _: 1
            }, 8, ["onClose"]))
            : _createCommentVNode("", true)
    ], 64));
}
